import { skipToken } from '@reduxjs/toolkit/query/react';

import type { UserApiOptions } from '@/store/api/userApi';

import { useGetUserQuery, useGetUsersQuery } from '@/store/api/userApi';


interface UseGetUsersOptions {
  enabled?: boolean;
}

export const useGetUsers = (
  params: UserApiOptions,
  options?: UseGetUsersOptions,
) => useGetUsersQuery(params, {
  skip: options?.enabled === false,
});

export const useGetUser = (id: string, options?: UseGetUsersOptions) =>
  useGetUserQuery(
    (options?.enabled === false || !id) ? skipToken : id
  );
